<app-nav-menu></app-nav-menu>
<div class="Main_page">
  <p-toast></p-toast>
  <div class="row m-0 p-0">
    <div class="col-md-12 p-0">
      <div class="SearchPannel">
        <div class="row m-0">
          <div class="heading_page">
            <span>Offline Back Office Report</span>
          </div>
        </div>
        <form #bookingForm="ngForm" (ngSubmit)="onSubmit()">
          <div class="row m-0 mt-3">
            <div class="col-md-11 p-0">
              <div class="row m-0 mt-1">

                <!-- Booking From Date -->
                <div class="col-md-2 p-0">
                  <input type="date"
                    class="new_input_fields"
                    name="fromBookingDate"
                    [(ngModel)]="offlineProperties.startDate"
                    #fromBookingDate="ngModel">
                    <label class="input_lab_first">Booking From</label>
                  </div>

                  <!-- Booking To Date (Conditional Requirement) -->
                  <div class="col-md-2 p-0 pl-1">
                    <input type="date"
                      class="new_input_fields"
                      name="toBookingDate"
                      [(ngModel)]="offlineProperties.endDate"
                      #toBookingDate="ngModel"
                      [required]="offlineProperties.startDate">
                      <label class="input_lab_first">Booking To</label>
                      @if (offlineProperties.startDate && toBookingDate.invalid && toBookingDate.touched) {
                        <div class="error">
                          Booking To date is required if Booking From date is selected.
                        </div>
                      }
                    </div>

                    <!-- Optional Booking ID -->
                    <div class="col-md-2 p-0 pl-1">
                      <input type="number"
                        class="new_input_fields"
                        name="bookingID"
                        [(ngModel)]="offlineProperties.bookingId">
                        <label class="input_lab_first">Booking ID</label>
                      </div>

                      <!-- Optional Agency Selection -->
                      <div class="col-md-2 p-0 pl-1">
                        <ng-select [items]="agencyCodeList$ | async"
                          bindLabel="labelName"
                          bindValue="code"
                          [searchable]="true"
                          class="statusselect"
                          name="byAgency"
                          (blur)="getlistofUsers(offlineProperties.agencyBranchId)"
                          [(ngModel)]="offlineProperties.agencyBranchId">
                        </ng-select>
                        <label class="input_lab_first">Requesting Agency</label>
                      </div>

                      <!-- Optional Manager Selection -->
                      <div class="col-md-2 p-0 pl-1">
                        <ng-select [items]="userlist"
                          bindLabel="fullname"
                          bindValue="userId"
                          [searchable]="true"
                          class="statusselect"
                          name="loginUserId"
                          [(ngModel)]="offlineProperties.creationUser">
                        </ng-select>
                        <label class="input_lab_first">Requesting User</label>
                      </div>

                      <!-- Optional Request Type Selection -->
                      <div class="col-md-2 p-0 pl-1">
                        <ng-select [items]="getOfflineRequestTypeList"
                          bindLabel="typeName"
                          bindValue="offlineRequestTypeId"
                          [searchable]="true"
                          class="statusselect"
                          name="loginUserId"
                          [(ngModel)]="offlineProperties.offlineBookingRequestId">
                        </ng-select>
                        <label class="input_lab_first">Request Type</label>
                      </div>
                      <div class="col-md-2 p-0 pl-1">
                        <ng-select [items]="offlineStatusNew"
                          bindLabel="name"
                          bindValue="id"
                          [searchable]="true"
                          class="statusselect"
                          name="loginUserId"
                          [(ngModel)]="offlineProperties.status">
                        </ng-select>
                        <label class="input_lab_first">Status</label>
                      </div>

                    </div>
                  </div>

                  <!-- Submit Button -->
                  <div class="col-md-1">
                    <button type="submit" class="LoadButton">
                      Load
                      <span class="load loading"></span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

        </div>
        @if (datasoruceBooking.length>0) {
          <div class="row m-0 p-1">
            <div class="col-md-4 ">
              <div style="background: white; border: 1px solid silver; box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;padding:10px;border-radius:5px">
                <p-chart type="doughnut" [height]="160" [data]="dataStatus" [options]="options"></p-chart>
              </div>
            </div>
            <!--<div class="col-md-4">
            <div style="background: white; border: 1px solid silver; box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;padding:10px;border-radius:5px">
              <p-chart type="doughnut" [height]="160" [data]="dataRequestTypeOnline" [options]="options"></p-chart>
            </div>
          </div>-->
          <div class="col-md-4 ">
            <div style="background: white; border: 1px solid silver; box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;padding:10px;border-radius:5px">
              <p-chart type="doughnut" [height]="160" [data]="dataRequestTypeOffline" [options]="options"></p-chart>
            </div>
          </div>
        </div>
      }

      <dx-data-grid id="gridContainer"
        [dataSource]="datasoruceBooking"
        [allowColumnReordering]="true"
        [width]="'100%'"
        [showBorders]="true" (onExporting)="onExporting($event)">
        <dxi-column [visible]="false"
          dataField="offlineId"
        dataType="number"></dxi-column>
        <dxi-column [visible]="false"
          dataField="currentBookingStatus"
        dataType="string"></dxi-column>
        <dxi-column [visible]="false"
          dataField="inProgressTag"
        dataType="string"></dxi-column>
        <dxi-column [visible]="false"
          alignment="center"
          caption="Request Type Id"
          dataField="offlineRequestType"
        dataType="string"></dxi-column>

        <dxi-column alignment="center"
          caption="Request Type"
          dataField="offlineRequestTypeName"
        dataType="string"></dxi-column>
        <dxi-column alignment="center"
          caption="Agency"
          dataField="requestingAgency"
        dataType="string"></dxi-column>
        <dxi-column alignment="center"
          caption="Booking Id"
        dataField="offlineId"></dxi-column>
        <dxi-column alignment="center"
          caption="Requesting date"
          dataField="creationDate"
          dataType="Date"
        format="dd-MM-yyyy"></dxi-column>

        <dxi-column alignment="center"
          caption="Requesting User"
          dataField="requestingUserName"
        dataType="string"></dxi-column>
        <dxi-column alignment="center"
          caption="Trip"
          dataField="sector"
        dataType="string"></dxi-column>
        <dxi-column alignment="center" [visible]="false"
          caption="Action Date"
          dataField="lastActivityTime"
        dataType="string"></dxi-column>
        <dxi-column alignment="center" [visible]="false"
          caption="Action User"
          dataField="assignedUser"
        dataType="string"></dxi-column>
        <dxi-column caption="Booking Status"
          alignment="center"
          dataField="bookingStatusName"
        dataType="string"></dxi-column>




        <dxi-column caption="Action" type="buttons" [width]="60">
          <dxi-button hint="Edit"
            icon="edit"
          [onClick]="onClickEditRequest"></dxi-button>
        </dxi-column>
        <dxo-selection mode="multiple"></dxo-selection>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-paging [pageSize]="10"></dxo-paging>
        <dxo-group-panel [visible]="true"></dxo-group-panel>
        <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
        <dxo-export [enabled]="true" [allowExportSelectedData]="true">Export</dxo-export>
      </dx-data-grid>
      <div class="options">
        <div class="caption">Options</div>
        <div class="option">
          <dx-check-box id="autoExpand"
            [(value)]="expand.autoExpandAll"
            text="Expand All Groups">
          </dx-check-box>
        </div>
      </div>

    </div>
